import { suppressResizeObserverError } from './utils/suppressResizeObserverError';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from "react-redux"
import configureStore from './store/configureStore';

import { BrowserRouter } from "react-router-dom";

// Works for both `npm start` and `npm run build` (HTML head script also covers early race).
suppressResizeObserverError();

const configured = configureStore();
window.store = configured.store;

const root = ReactDOM.createRoot(document.getElementById('root'));
require("./services/axios");

root.render(
  // <React.StrictMode>
    <Provider {...configured}>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>,
  // document.getElementById('root')
);
